export default __webpack_public_path__ + "images/defe211ca0045e7c8297f6aafe9fc135-mobile_small.webp";